import SeoHead from '../components/SeoHead'

export default function TermsOfService() {
  return (
    <section className="bg-white py-16 px-6">
      <SeoHead
        title="Terms of Service | East County Business Center"
        description="Terms of service for East County Business Center — booking, cancellation, and membership policies."
        path="/terms-of-service"
      />
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold text-ecbc-navy mb-8">Terms of Service</h1>

        <div className="space-y-8 text-gray-600 leading-relaxed">
          <div>
            <h2 className="text-lg font-bold text-ecbc-navy mb-2">1. Acceptance of Terms</h2>
            <p>By using the site or services, users agree to these terms.</p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-ecbc-navy mb-2">2. Services Offered</h2>
            <p>
              Virtual Business Address, Professional Mailbox, Part-Time Office Space,
              Full-Time Private Offices, Conference Room Rental, and membership plans.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-ecbc-navy mb-2">3. Booking Policy</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>All bookings are subject to availability</li>
              <li>Bookings are confirmed only upon successful payment</li>
              <li>
                ECBC reserves the right to cancel any booking and issue a full refund at its
                discretion (e.g. space unavailability, maintenance, or force majeure)
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-bold text-ecbc-navy mb-2">4. Cancellation & Refund Policy</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>A 10% cancellation fee applies to all refunds, since payment is charged upfront at booking</li>
              <li>Cancellations made more than 48 hours before the scheduled booking start time are eligible for a 90% refund</li>
              <li>Cancellations made within 48 hours of the scheduled booking start time will receive a 50% refund</li>
              <li>No refund will be issued for no-shows</li>
              <li>Refunds are processed automatically at the time of cancellation and may take 1–3 business days to appear on your original payment method</li>
              <li>
                A booking may be rescheduled or have time added or removed instead of cancelled. Removing time from a
                booking follows the same 90%/50% refund tiers as a full cancellation, applied to the value of the
                time removed. If a booking is rescheduled within 48 hours of a later cancellation or time-removal,
                the refund tier is based on whichever of its original or new time is sooner — a reschedule cannot be
                used to reset the refund tier in your favor
              </li>
              <li>Adding time to a booking requires a card on file and is billed at the time of the change; there is no cancellation fee for adding time</li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-bold text-ecbc-navy mb-2">5. Membership Policy</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Memberships are billed on the 1st of each month</li>
              <li>Members may cancel at any time</li>
              <li>No refunds are issued for the current billing cycle upon cancellation</li>
              <li>Access to all membership benefits continues through the end of the current billing cycle</li>
              <li>ECBC reserves the right to terminate a membership for violation of these terms</li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-bold text-ecbc-navy mb-2">6. Conduct & Use of Facilities</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Members and guests must treat shared spaces with respect</li>
              <li>No illegal activity on premises</li>
              <li>ECBC is not responsible for lost or stolen personal property</li>
              <li>Food and beverages are permitted in designated areas only</li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-bold text-ecbc-navy mb-2">7. Intellectual Property</h2>
            <p>All site content, branding, and materials are owned by East County Business Center LLC.</p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-ecbc-navy mb-2">8. Limitation of Liability</h2>
            <p>
              ECBC is not liable for indirect, incidental, or consequential damages arising from use
              of the facilities or services.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-ecbc-navy mb-2">9. Changes to Terms</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>ECBC reserves the right to update these terms at any time</li>
              <li>Continued use of services after changes constitutes acceptance</li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-bold text-ecbc-navy mb-2">10. Contact</h2>
            <p>
              East County Business Center LLC<br />
              270 East Douglas Ave, El Cajon, CA 92020<br />
              <a href="tel:6194014000" className="text-ecbc-navy underline">(619) 401-4000</a><br />
              <a href="mailto:info@eastcountybiz.com" className="text-ecbc-navy underline">info@eastcountybiz.com</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
